// Pausa automática do Sucesso (Douglas 09/09/2026): depois de tabular Sucesso o consultor
// é pausado sozinho (motivo "Tabulação") para mandar o WhatsApp e falar com o cliente.
// Só ESSA pausa tem relógio: 5 min, contados pelo servidor (motor), que despausa ao vencer.
// Aqui fica a régua que a tela usa para mostrar a contagem regressiva — o mesmo número
// do motor (DISCADORA_PAUSA_SUCESSO_MAX_S). As demais pausas seguem sem limite.
export const PAUSA_SUCESSO_LIMITE_S = 300;
export const MOTIVO_PAUSA_TABULACAO_ID = '2b506952-1f63-4d95-b9c2-16e523ed1d9b';

export function ehPausaDoSucesso(motivoNome: string | null | undefined): boolean {
  return (motivoNome || '').trim().toLowerCase() === 'tabulação';
}

/** Segundos que faltam para o servidor despausar (0 quando venceu). */
export function restantePausaSucesso(pausedSince: Date | null | undefined, agora = Date.now()): number {
  if (!pausedSince) return PAUSA_SUCESSO_LIMITE_S;
  const decorrido = Math.floor((agora - pausedSince.getTime()) / 1000);
  return Math.max(0, PAUSA_SUCESSO_LIMITE_S - decorrido);
}

export function formatarMmSs(segundos: number): string {
  const s = Math.max(0, Math.floor(segundos));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
